var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6884 4.33768H4.33766C3.1448 4.33768 2.16882 5.31365 2.16882 6.50651V19.5195C2.16882 20.7124 3.1448 21.6884 4.33766 21.6884H21.6884C22.8812 21.6884 23.8572 20.7124 23.8572 19.5195V6.50651C23.8572 5.31365 22.8812 4.33768 21.6884 4.33768ZM21.2546 8.94646L14.1625 13.3817C13.4576 13.8263 12.5684 13.8263 11.8635 13.3817L4.77143 8.94646C4.50032 8.77295 4.33766 8.48016 4.33766 8.16567C4.33766 7.43911 5.12929 7.00535 5.7474 7.38489L13.013 11.9286L20.2786 7.38489C20.8967 7.00535 21.6884 7.43911 21.6884 8.16567C21.6884 8.48016 21.5257 8.77295 21.2546 8.94646Z",
    fill: "#2AA7E0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/Email Icon.c6a65d22da5e75bbf8502c811c187815.svg";
export { ForwardRef as ReactComponent };